import { render, staticRenderFns } from "./PhyThrCard.vue?vue&type=template&id=784ed9a9&"
import script from "./PhyThrCard.vue?vue&type=script&lang=js&"
export * from "./PhyThrCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports